/**
* Link Blocks JS
* -----------------------------------------------------------------------------
*
* All the JS for the Link Blocks component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'link-blocks',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {

    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'link-blocks', COMPONENT );
} )( app );
